/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { AiAgentV2ControllerSaveAddendumToProjectMutationResponse } from "../../models/aiAgentV2Controller/AiAgentV2ControllerSaveAddendumToProject";

function getAiAgentV2ControllerSaveAddendumToProjectUrl() {
  const res = { method: 'POST', url: `/api/v1/ai-agent-v2/save-addendum-to-project` as const }  
  return res
}

/**
 * @description Fetches the addendum DOCX artifact from S3 and creates a new standalone file in the project with document type OTHER. Does not create a version in any existing file chain.
 * @summary Save an AI-generated addendum DOCX as a new project document
 * {@link /api/v1/ai-agent-v2/save-addendum-to-project}
 */
export async function aiAgentV2ControllerSaveAddendumToProject(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<AiAgentV2ControllerSaveAddendumToProjectMutationResponse, ResponseErrorConfig<Error>, unknown>({ method : "POST", url : getAiAgentV2ControllerSaveAddendumToProjectUrl().url.toString(), ... requestConfig })  
  return res.data
}